function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_949",
  "data-name": "Ret\\xE2ngulo 949",
  width: 18.5,
  height: 11.54,
  fill: "none"
})));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_1213-2",
  "data-name": "Grupo 1213",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_1525",
  "data-name": "Caminho 1525",
  d: "M40.556,2.976A.969.969,0,0,1,41,4.065,2.871,2.871,0,0,1,38.7,6.222c-.424.056-.863-.007-1.294.009-.138,0-.367.063-.387.14a.487.487,0,0,0,.126.424,11.22,11.22,0,0,0,1.216.822,1.283,1.283,0,0,1,.718.806,1.979,1.979,0,0,0,.764,1.11A2.136,2.136,0,0,0,40,9.4c2.217-2.218,4.446-4.426,6.642-6.665A12.908,12.908,0,0,0,47.992,1c.148-.214.3-.611.2-.771-.2-.325-.616-.24-.958-.143a3.052,3.052,0,0,0-.527.227q-.562.283-1.117.58a6.208,6.208,0,0,1-3.58.728c-.5-.048-.991-.168-1.485-.262-.44-.083-.582.028-.586.464a1.292,1.292,0,0,0,.618,1.152",
  transform: "translate(-34.336 0)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_1526",
  "data-name": "Caminho 1526",
  d: "M12.251,14.483c.066-.028.163.021.247.031a2.3,2.3,0,0,0,2.767-1.455.472.472,0,0,0-.185-.671,1.854,1.854,0,0,1-.822-1.451A.475.475,0,0,0,14.2,10.7c-.257-.344-.524-.679-.833-1.075l-3.335,3.537c.329.264.759.608,1.188.953.3.243.571.564,1.035.366",
  transform: "translate(-9.305 -8.933)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_1527",
  "data-name": "Caminho 1527",
  d: "M161.069,49.925a.443.443,0,0,0,.558.008q2.745-2.044,5.493-4.083a1.953,1.953,0,0,0,.269-.323,2.321,2.321,0,0,0-.286-.335c-.377-.3-.766-.58-1.15-.868-.41-.307-.488-.3-.842.07q-2.106,2.2-4.212,4.4c-.61.636-.6.673.17,1.13",
  transform: "translate(-148.889 -40.923)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_1528",
  "data-name": "Caminho 1528",
  d: "M18.122,150.487c-.065-.046-.187-.012-.283-.012H.573c-.108,0-.242-.031-.317.02-.114.078-.257.217-.256.327s.159.236.278.3a.832.832,0,0,0,.355.017H17.756a.836.836,0,0,0,.355-.014c.128-.067.308-.2.306-.306s-.172-.245-.295-.331",
  transform: "translate(0 -139.61)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_1529",
  "data-name": "Caminho 1529",
  d: "M87.694,18.707Q85,21.4,82.311,24.084a1.831,1.831,0,0,1-.353.217c.455.365.732.349,1.075.008q3.294-3.284,6.581-6.576a2.933,2.933,0,0,0,.862-1.473,3.986,3.986,0,0,0,.009-.781,16.964,16.964,0,0,1-2.79,3.228",
  transform: "translate(-76.046 -14.363)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_1530",
  "data-name": "Caminho 1530",
  d: "M219,97.651c.207.5.39,1,.581,1.508.349.916.349.916,1.386.849l-1.23-3.213c-.229.168-.412.32-.612.443a.28.28,0,0,0-.126.412",
  transform: "translate(-203.168 -89.813)"
}));
function SvgEcoConducao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_1213",
    "data-name": "Grupo 1213",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.5,
    height: 11.54,
    viewBox: "0 0 18.5 11.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcoConducao);
export default __webpack_public_path__ + "static/media/eco-conducao.c8903a96.svg";
export { ForwardRef as ReactComponent };